const toyotTypeLight = 'toyotatype-light.ttf';
const toyotTypeBold = 'toyotatype-bold.ttf';
const toyotTypeSemibold = 'toyotatype-semibold.otf';
const toyotTypeItalics = 'toyotatype-regularit.ttf';
const toyotTypeBoldItalics = 'toyotatype-bookit.ttf';
const nobelRegular = 'nobel-regular.ttf';
const nobelBold = 'nobel-bold.ttf';
export const  fonts = {
    toyota: {
        normal: 'toyotatype-regular.ttf',
        light: toyotTypeLight,
        bold: toyotTypeBold,
        italics: toyotTypeLight,
        bolditalics: toyotTypeSemibold
    },
    toyotalight: {
        normal: toyotTypeLight,
        bold: toyotTypeBold,
        italics: toyotTypeItalics,
        bolditalics: toyotTypeBoldItalics
    },
    toyotasemibold: {
        normal: toyotTypeSemibold,
        bold: toyotTypeBold,
        italics: toyotTypeItalics,
        bolditalics: toyotTypeBoldItalics
    },
    toyotabook: {
        normal: 'toyotatype-book.ttf',
        bold: toyotTypeBold,
        italics: 'toyotatype-light.ttf',
        bolditalics: toyotTypeSemibold
    },
    helvetica: {
        normal: 'HelveticaNeueW01-45Light.ttf',
        bold: 'HelveticaNeueW01-75Bold.ttf',
        italics: 'HelveticaNeueW01-65Medium.ttf',
        bolditalics: 'HelveticaNeueW01-75Bold.ttf'
    },
    nobel: {
        normal: nobelRegular,
        light: nobelRegular,
        bold: nobelBold,
        italics: nobelRegular,
        bolditalics: nobelBold
    },
};